import { useNumberMask } from "@common/hooks/useMask";
import useCustomerInfoFromQuery from "@modules/query-string/hooks/useCustomerInfoFromQuery";
import useVehicleInfoFromQuery from "@modules/query-string/hooks/useVehicleInfoFromQuery";
import useSourceInfoFromQuery from "@modules/query-string/hooks/useSourceInfoFromQuery";
import { StartPurchaseRequest } from "@modules/purchase/warranty/types/Purchase";

const useConsumerFinancingFromQuery = () => {
  const { unMaskPipe: unMaskNumberPipe } = useNumberMask();
  const vehicleInformation = useVehicleInfoFromQuery();
  const customerInformation = useCustomerInfoFromQuery();
  const {
    sourceAdId,
    sourceAppId,
    sourceLocationId,
    sourceSessionId,
    sourceUserId,
    sourceCtaId,
    source,
  } = useSourceInfoFromQuery();

  return {
    vin: vehicleInformation.vin,
    year: vehicleInformation.year,
    make: vehicleInformation.make,
    model: vehicleInformation.model,
    trim: vehicleInformation.trim,
    mileage: vehicleInformation.odometer
      ? unMaskNumberPipe(vehicleInformation.odometer)
      : null,
    purchaseDate: vehicleInformation.purchaseDate,
    purchasePrice: vehicleInformation.purchasePrice
      ? unMaskNumberPipe(vehicleInformation.purchasePrice)
      : null,
    coverImage: vehicleInformation.coverImage,
    firstName: customerInformation.firstName,
    lastName: customerInformation.lastName,
    email: customerInformation.email,
    phone: customerInformation.phoneNumber,
    address: customerInformation.streetAddress,
    city: customerInformation.city,
    province: customerInformation.province?.abbr,
    postalCode: customerInformation.postalCode,
    sourceAdId,
    sourceAppId,
    sourceLocationId,
    sourceSessionId,
    sourceUserId,
    sourceCtaId,
    source,
  } as StartPurchaseRequest;
};

export default useConsumerFinancingFromQuery;
